import { action, computed } from 'mobx';
import { ComponentTypes } from '~constants/ComponentTypes';
import { ProductBaseController } from '../../../src/internal/controllers/ProductBaseController';
import { IProductDetails } from '../interfaces/IProductFull';
import { buildIngredientsContent } from '../utils/ContentFormatter';
import { IComparisonItemWrapper } from '../views/product-comparison/ComparisonItemWrapper';

export class ComparisonItemViewController extends ProductBaseController {
    @action
    public initialize(props: IComparisonItemWrapper) {
        this.setProduct(props.product);
        this.positionIndex = props.positionIndex;
    }

    @computed
    public get data() {
        return {
            ...this.baseData,
            displayName: this.product.displayNameDecoded,
            alternateImage: this.getCustomSizeAlternateImage(ComponentTypes.PRODUCT_BRIEF),
            isUpdatedInventorySource: this.selectedSku.isUpdatedInventorySource,
            selectedAutoReplenishOption: this.selectedAutoReplenishOption
        };
    }

    @computed
    public get productDetails(): IProductDetails {
        const {
            whoItsFor: { content: whoItsFor },
            greatToKnow: { content: greatToKnow },
            whatItIs: { content: whatItIs },
            whatItDoes: { content: whatItDoes },
            keyIngredient,
            howDoesItWork: { content: howDoesItWork },
            howToUse: { content: howToUse },
            fragranceKeyNotes
        } = this.product;
        const allIngredients = buildIngredientsContent(this.selectedSku);

        return {
            whoItsFor,
            greatToKnow,
            whatItIs,
            whatItDoes,
            keyIngredient,
            allIngredients,
            howDoesItWork,
            howToUse,
            fragranceKeyNotes
        };
    }
}
